const isNode = process.env.ISNODE;
/**
\
 * Based on the hostname determine whether api client should use a relative link
 * @param {*} hostname 
 */
export const useRelativeLink = () => {
    let currHost = isNode ? 'server' : document.location.hostname;
    return currHost !== 'server' && currHost !== 'localhost' && currHost.indexOf("hpstoreapp") < 0
}